import keyMirror from "keymirror";

export default keyMirror({
    "not-rated": null,
    negative: null,
    neutral: null,
    positive: null,
});
